import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { I18nextProvider } from "react-i18next";
import i18n from "Common/i18n";
import { Elements } from "@stripe/react-stripe-js";

import LoaderModal from "Layout/loader";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export const store = configureStore({ reducer: rootReducer, devTools: true });
root.render(
  <React.Fragment>
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <I18nextProvider i18n={i18n}>
          
            <App />
            <LoaderModal  />

        </I18nextProvider>
      </BrowserRouter>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
